import { StyleSheet } from 'aphrodite';

export const styleSheet = StyleSheet.create({
	trigger: {
		height: 'auto',
		padding: '4px 8px',
		fontSize: '0.8125rem',
		border: 'none',
		boxShadow: 'none',
		outline: 'none',
		backgroundColor: 'transparent',
		cursor: 'pointer',
	},
	content: {
		minWidth: 160,
	},
	subContent: {
		minWidth: 200,
	},
});
